import React from 'react';
import {observer} from 'mobx-react';
import _ from 'lodash';
import {t} from 'shared/core';
import {Button, Panel} from 'components';
import OptionalCoveragesListForCarrier from './OptionalCoveragesListForCarrier';
import {FormattedMessage} from 'react-intl';

const OptionalCoverages = observer(({uiState}) => {
  const {editable, benefitInfo, companyInsuranceCarriers} = uiState;
  const {optionalCoverageEnrolments} = benefitInfo;

  if (!editable || _.isEmpty(optionalCoverageEnrolments)) return null;

  return (
    <Panel>
      <Panel.Header
        title={t('benefit_enrolment.details.optional_coverage.Optional Benefits Coverage')}
        description={t('benefit_enrolment.details.optional_coverage.Fill in the fields below if the employee has opted into optional coverages provided by their benefits plan. The cost of coverage should be a unique dollar amount based on the employee’s benefit information. These fields are required to accurately calculate the deductions for the taxable benefits report.')}
      />
      {
        companyInsuranceCarriers.map(c =>
          <OptionalCoveragesListForCarrier key={c.id} uiState={uiState} carrierName={c.name}/>)
      }
      <div className='mt2'>
        <Button onClick={() => uiState.saveOptionalCoverages()}>
          <FormattedMessage id='Save'/>
        </Button>
      </div>
    </Panel>
  );
});

export default OptionalCoverages;
